module.exports = __webpack_public_path__ + "static/media/MemberDataIcon.2579a1d5.svg";